export const OPTIONS = {
  'visual-builder': {
    basicOptions: [{ key: 'listVisuals', defaultValue: true }],
    advancedOptions: [],
  },
  'dashboard-builder': {
    basicOptions: [{ key: 'listDashboards', defaultValue: true }],
    advancedOptions: [],
  },
  'report-builder': {
    basicOptions: [{ key: 'listReports', defaultValue: true }],
    advancedOptions: [],
  },
  'chat-bot': {
    basicOptions: [{ key: 'chatBotBotApi', defaultValue: true }],
    advancedOptions: [],
  },
};
